<div class="w-full h-full overflow-hidden">
  <div
    *ngIf="(notLimitedView$ | async) && (isAdexHome$ | async)"
    class="adex-home-buttons"
  >
    <p-button
      styleClass="p-button-outlined"
      (onClick)="navigateToCreativeReport()"
      >Creative Report</p-button
    >
    <p-button
      styleClass="p-button-outlined"
      (onClick)="navigateToCampaignReport()"
      >Campaign Report</p-button
    >
    <p-button (onClick)="navigateToCreateCampaign()">Create Campaign</p-button>
  </div>
  <iframe
    #iframe
    *ngIf="iframeSrc$ | async as iframeSrc"
    [src]="iframeSrc"
  ></iframe>
</div>
